<div class="heroitem__container flex items-center gap-2">
  <ng-container *ngIf="!pending && !info && !warning">
    <sbnb-icon icon="check" *ngIf="positive" class="text-grass-darker"></sbnb-icon>
    <sbnb-icon [size]="22" icon="delete" *ngIf="!positive" class="text-rose-darker"></sbnb-icon>
  </ng-container>
  <sbnb-icon [size]="20" icon="time" *ngIf="pending" class="text-lemon-darker"></sbnb-icon>
  <sbnb-icon [size]="20" icon="alert-triangle" *ngIf="warning" class="text-lemon-darker"></sbnb-icon>
  <sbnb-icon [size]="20" icon="information" *ngIf="info" class="text-night-lighter information-icon"></sbnb-icon>

  <div class="flex-1">
    <ng-content></ng-content>
  </div>
</div>
